export default "__VITE_ASSET__2d265e2e__"